import React, { useState } from 'react';

export const OFFLINE_PAYMENT_MODES = [
  { value: 'offline_cash', label: 'Cash' },
  { value: 'offline_bank', label: 'Bank transfer' },
  { value: 'offline_cheque', label: 'Cheque' },
];

const defaultForm = { payment_mode: 'offline_cash', receipt_no: '', remarks: '' };

/**
 * Modal for admin to record offline customer payment (cash, bank, cheque).
 */
function AdminRecordOfflinePaymentModal({
  open,
  onClose,
  onSubmit,
  title = 'Record offline payment',
  amount,
  currencyCode = 'NPR',
  submitting = false,
}) {
  const [form, setForm] = useState(defaultForm);

  if (!open) return null;

  const handleClose = () => {
    setForm(defaultForm);
    onClose();
  };

  const handleSubmit = () => {
    onSubmit({
      payment_mode: form.payment_mode,
      receipt_no: form.receipt_no.trim() || undefined,
      remarks: form.remarks.trim() || undefined,
    });
  };

  return (
    <div className="modal fade show d-block" style={{ background: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="close" onClick={handleClose} disabled={submitting}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {amount != null && (
              <p className="text-muted small mb-3">
                Amount: <strong>{Number(amount).toLocaleString()} {currencyCode}</strong>
              </p>
            )}
            <div className="form-group">
              <label>Payment method</label>
              <select
                className="form-control"
                value={form.payment_mode}
                onChange={(e) => setForm({ ...form, payment_mode: e.target.value })}
                disabled={submitting}
              >
                {OFFLINE_PAYMENT_MODES.map((m) => (
                  <option key={m.value} value={m.value}>{m.label}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Receipt / reference no. <span className="text-muted">(optional)</span></label>
              <input
                type="text"
                className="form-control"
                value={form.receipt_no}
                onChange={(e) => setForm({ ...form, receipt_no: e.target.value })}
                placeholder="e.g. bank ref, receipt #"
                disabled={submitting}
              />
            </div>
            <div className="form-group mb-0">
              <label>Remarks <span className="text-muted">(optional)</span></label>
              <input
                type="text"
                className="form-control"
                value={form.remarks}
                onChange={(e) => setForm({ ...form, remarks: e.target.value })}
                placeholder="e.g. paid at office"
                disabled={submitting}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={handleClose} disabled={submitting}>
              Cancel
            </button>
            <button type="button" className="btn btn-success" onClick={handleSubmit} disabled={submitting}>
              {submitting ? 'Recording…' : 'Mark as paid'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminRecordOfflinePaymentModal;
